import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center",
  style: {"align-items":"flex-end"}
}

import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { usePolizze, useWidget } from "@/composables";
import Loading from "../../loading.vue";
import FormPreventivatore from "./formPreventivatore.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const { widgetConfig } = useWidget();
const { loading } = usePolizze();
const usaFasce = ref<boolean>(false);


onMounted(() => {
    //dataPrenotazione.value = dayjs(today.value);
    usaFasce.value = widgetConfig.value && widgetConfig.value.usaFasceEta ? true : false;

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "webins-widget-step-0",
      style: _normalizeStyle({ 'background-image': `url(https://webins.it/wp-content/uploads/2023/07/1-nuovahomeRID.jpg)`, 'background-position': '0px 40%' })
    }, [
      (!_unref(widgetConfig) || !_unref(widgetConfig).abilitaAggiuntaCarrello)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FormPreventivatore)
          ]))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(Loading, { isloading: _unref(loading) }, null, 8, ["isloading"])
  ], 64))
}
}

})